module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABABAMAAAAe8c9HAAAAFVBMVEX///9DfrkAAAAcOVVIkdllZWX///+AHV2mAAAAAnRSTlPQ/TSnhoYAAAA2SURBVHjaYxRkIBUwuoxqGdUyqmVEajEmXYvSqJZRLaNaRqSWUNK1pI1qGdUyqmVEaiFZBwMAtgMQyqLdducAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/ee.png
// module id = hXIL
// module chunks = 0